import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import { Carousel } from "react-responsive-carousel";
import { Modal, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useHistory } from "react-router";
// import { data } from "./data.js";
import { FACILITIES, AMENITIES } from "../../utilis/const";
import GoogleMap2 from "../../components/GoogleMap";
import TableSimple from "../../components/Table/TableWithoutHeaders";
import { useDispatch, useSelector } from "react-redux";
import { getHotelsDetails } from "../../redux/actions/HotelActions";
import { useParams } from "react-router-dom";
import { separator } from "../../utilis/functions";

function removeDuplicatePhotos(photos) {
    const uniqueUrls = new Set();
    let filteredPhotos = [];
    filteredPhotos = photos?.filter((photo) => {
        const url = photo.Photo;
        if (!uniqueUrls.has(url)) {
            uniqueUrls.add(url);
            return true;
        }
        return false;
    });
    return filteredPhotos;
}

function removeDuplicateRooms(rooms) {
    const uniqueIds = {};
    let filteredRooms = [];
    filteredRooms = rooms?.filter((room) => {
        if (!uniqueIds[room.id]) {
            // Mark the id as seen and keep the room
            uniqueIds[room.id] = true;
            return true;
        }
        return false;
    });
    return filteredRooms;
}

const StaticContent = (props) => {
    const { id } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [showMoreFacilities, setShowMoreFacilities] = useState(false);
    const [reportMappingError, setReportMappingError] = useState(false);
    const [openModalRooms, setOpenModalRooms] = useState(false);
    const [currentRoomImages, setCurrentRoomImages] = useState([]);
    const { data, loadingHotelDetails } = useSelector((state) => ({
        data: state.hotelsReducer.hotelDetails ?? {},
        loadingHotelDetails: state.hotelsReducer.loadingHotelDetails,
    }));

    const renderTooltip = (props = (text) => {
        return (
            <Tooltip
                id={`button-tooltip ${text}`}
                {...props}
                style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "inline-flex",
                    color: "#F5F6FA",
                    fontSize: "15px",
                    fontFamily: "Lato",
                    fontWeight: "400",
                }}
            >
                {text}
            </Tooltip>
        );
    });

    const generateStars = (stars) => {
        const starElements = [];
        for (let i = 1; i <= stars; i++) {
            starElements.push(
                <div
                    key={i}
                    style={{
                        width: "24px",
                        height: "24px",
                        position: "relative",
                    }}
                >
                    <Star />
                </div>
            );
        }
        return starElements;
    };

    useEffect(() => {
        dispatch(getHotelsDetails(id));
    }, [id]);

    return (
        <>
            <Helmet>
                <title> Inventory</title>
            </Helmet>
            <div className="page-wrapper" style={{ display: "block" }}>
                {loadingHotelDetails ? (
                    <div className="text-center">
                        <div className="lds-ripple">
                            <div className="lds-pos"></div>
                            <div className="lds-pos"></div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="page-breadcrumb">
                            <div className="row">
                                <div className="col-md-12">
                                    <div
                                        style={{
                                            color: "#6275E7",
                                            fontSize: "18px",
                                            fontFamily: "Lato",
                                            fontWeight: "700",
                                            wordWrap: "break-word",
                                            display: "flex",
                                            gap: "8px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            history.push(
                                                "/catalogs-manager/hotels-list"
                                            )
                                        }
                                    >
                                        <button
                                            class="btn"
                                            style={{ padding: "0px" }}
                                        >
                                            <ArrowLeft1 />
                                        </button>
                                        <span style={{ textAlign: "center" }}>
                                            Back to Properties
                                        </span>
                                    </div>
                                </div>

                                <div
                                    class="col-12 align-self-center"
                                    style={{ paddingTop: "32px" }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <div>
                                                <div>
                                                    <span
                                                        style={{
                                                            color: "#141933",
                                                            fontSize: "28px",
                                                            fontFamily: "Lato",
                                                            fontWeight: "700",
                                                            // lineHeight: 40,
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {
                                                            data
                                                                ?.PropertyDetails
                                                                ?.name
                                                        }
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: "#141933",
                                                            fontSize: "22px",
                                                            fontFamily: "Inter",
                                                            fontWeight: "700",
                                                            // lineHeight: 32,
                                                            marginLeft: "4px",
                                                            marginRight: "4px",
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        •
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: "#505573",
                                                            fontSize: "28px",
                                                            fontFamily: "Lato",
                                                            fontWeight: "400",
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {
                                                            data
                                                                ?.PropertyDetails
                                                                ?.id
                                                        }
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        paddingTop: "8px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            color: "#505573",
                                                            fontSize: "18px",
                                                            fontFamily: "Lato",
                                                            fontWeight: "400",
                                                            wordWrap:
                                                                "break-word",
                                                        }}
                                                    >
                                                        {data?.PropertyDetails
                                                            ?.address !== ""
                                                            ? data
                                                                  ?.PropertyDetails
                                                                  ?.address
                                                            : "--"}
                                                        ,&nbsp;
                                                        {data?.PropertyDetails
                                                            ?.city !== ""
                                                            ? data
                                                                  ?.PropertyDetails
                                                                  ?.city
                                                            : "--"}
                                                        {data?.PropertyDetails
                                                            ?.country
                                                            ? `, ${data?.PropertyDetails?.country}`
                                                            : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*  <button
                                            onClick={() => {
                                                setReportMappingError(true);
                                            }}
                                            style={{
                                                height: "56px",
                                                paddingLeft: "24px",
                                                paddingRight: "24px",
                                                paddingTop: "16px",
                                                paddingBottom: "16px",
                                                borderRadius: "8px",
                                                border: "1px #878CA8 solid",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "16px",
                                                display: "inline-flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    position: "relative",
                                                }}
                                            >
                                                <Info />
                                            </div>
                                            <div
                                                style={{
                                                    color: "#141933",
                                                    fontSize: "18px",
                                                    fontFamily: "Lato",
                                                    fontWeight: "500",
                                                    wordWrap: "break-word",
                                                }}
                                            >
                                                Report Error
                                            </div>
                                        </button>*/}
                                    </div>
                                    {data?.PropertyDetails?.stars > 0 && (
                                        <div
                                            style={{
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                display: "inline-flex",
                                            }}
                                        >
                                            {generateStars(
                                                data?.PropertyDetails?.stars
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                }}
                            >
                                <div
                                    style={{
                                        flex: "1",
                                        width: "60%",
                                        marginRight: "32px",
                                    }}
                                >
                                    <span
                                        style={{
                                            color: "#141933",
                                            fontSize: "18px",
                                            fontFamily: "Lato",
                                            fontWeight: "400",
                                            wordWrap: "break-word",
                                        }}
                                    >
                                        {
                                            data?.PropertyDescription?.[0]
                                                ?.description
                                        }
                                    </span>
                                </div>
                                <div
                                    style={{
                                        width: "30%", // Ensure the inner container takes up the whole space
                                    }}
                                >
                                    {data?.PropertyPhotos?.length > 0 ? (
                                        <DisplayImages
                                            images={removeDuplicatePhotos(
                                                data?.PropertyPhotos
                                            )}
                                            setOpenModal={setOpenModal}
                                        />
                                    ) : (
                                        <NoImages />
                                    )}
                                </div>
                            </div>
                            {data?.Facilities?.filter((f) => f.property_id > 0)
                                ?.length > 0 && (
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        paddingTop: "80px",
                                        paddingBottom: "80px",
                                    }}
                                >
                                    <Facilities
                                        facilities={data?.Facilities}
                                        showMoreFacilities={showMoreFacilities}
                                        setShowMoreFacilities={
                                            setShowMoreFacilities
                                        }
                                        displayedFacilities={data?.Facilities?.filter(
                                            (m) => FACILITIES.has(m?.slug)
                                        )}
                                    />
                                </div>
                            )}

                            <PoliciesList policies={data?.PropertyPolicies} />
                            <DisplayRooms
                                data={data}
                                setOpenModalRooms={setOpenModalRooms}
                                setCurrentRoomImages={setCurrentRoomImages}
                                renderTooltip={renderTooltip}
                            />
                            <div
                                style={{
                                    width: "100%",
                                    flexWrap: "wrap",
                                    paddingTop: "80px",
                                }}
                            >
                                <GoogleMap2
                                    latitude={data?.PropertyDetails?.latitude}
                                    longitude={data?.PropertyDetails?.longitude}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
            {openModal && (
                <DisplayCarouselImages
                    images={removeDuplicatePhotos(data?.PropertyPhotos)}
                    open={openModal}
                    handleClose={() => {
                        setOpenModal(false);
                    }}
                    image="Photo"
                />
            )}
            {showMoreFacilities && (
                <AllFacilities
                    facilities={data?.Facilities}
                    open={showMoreFacilities}
                    handleClose={() => setShowMoreFacilities(false)}
                />
            )}

            {reportMappingError && (
                <ReportMappingError
                    reportMappingError={reportMappingError}
                    handleClose={() => setReportMappingError(false)}
                />
            )}
            {openModalRooms && (
                <DisplayCarouselImages
                    images={currentRoomImages}
                    open={openModalRooms}
                    handleClose={() => {
                        setOpenModalRooms(false);
                    }}
                    image="link"
                />
            )}
        </>
    );
};

export default StaticContent;

const ArrowLeft1 = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M19 12H5M5 12L12 19M5 12L12 5"
                stroke="#6275E7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

const Star = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g id="star-01">
                <path
                    id="Icon"
                    d="M11.2827 3.45307C11.5131 2.98613 11.6284 2.75266 11.7848 2.67807C11.9209 2.61317 12.0791 2.61317 12.2152 2.67807C12.3717 2.75266 12.4869 2.98613 12.7174 3.45307L14.9041 7.88304C14.9721 8.02089 15.0061 8.08982 15.0558 8.14333C15.0999 8.19071 15.1527 8.2291 15.2113 8.25638C15.2776 8.28718 15.3536 8.2983 15.5057 8.32053L20.397 9.03546C20.9121 9.11075 21.1696 9.14839 21.2888 9.27419C21.3925 9.38365 21.4412 9.53405 21.4215 9.68353C21.3988 9.85533 21.2124 10.0369 20.8395 10.4001L17.3014 13.8462C17.1912 13.9536 17.136 14.0073 17.1004 14.0712C17.0689 14.1278 17.0487 14.19 17.0409 14.2543C17.0321 14.3269 17.0451 14.4028 17.0711 14.5545L17.906 19.4219C17.994 19.9352 18.038 20.1919 17.9553 20.3443C17.8833 20.4768 17.7554 20.5697 17.6071 20.5972C17.4366 20.6288 17.2061 20.5076 16.7451 20.2652L12.3724 17.9656C12.2361 17.8939 12.168 17.8581 12.0962 17.844C12.0327 17.8316 11.9673 17.8316 11.9038 17.844C11.832 17.8581 11.7639 17.8939 11.6277 17.9656L7.25492 20.2652C6.79392 20.5076 6.56341 20.6288 6.39297 20.5972C6.24468 20.5697 6.11672 20.4768 6.04474 20.3443C5.962 20.1919 6.00603 19.9352 6.09407 19.4219L6.92889 14.5545C6.95491 14.4028 6.96793 14.3269 6.95912 14.2543C6.95132 14.19 6.93111 14.1278 6.89961 14.0712C6.86402 14.0073 6.80888 13.9536 6.69859 13.8462L3.16056 10.4001C2.78766 10.0369 2.60121 9.85533 2.57853 9.68353C2.55879 9.53405 2.60755 9.38365 2.71125 9.27419C2.83044 9.14839 3.08797 9.11075 3.60304 9.03546L8.49431 8.32053C8.64642 8.2983 8.72248 8.28718 8.78872 8.25638C8.84736 8.2291 8.90016 8.19071 8.94419 8.14333C8.99391 8.08982 9.02793 8.02089 9.09597 7.88304L11.2827 3.45307Z"
                    fill="#EAB80A"
                />
            </g>
        </svg>
    );
};

const Info = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g id="info-circle">
                <path
                    id="Icon"
                    d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="#505573"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>
    );
};

const DisplayImages = ({ images, setOpenModal }) => {
    return (
        <div
            className="image-grid"
            style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
            }}
        >
            {images?.slice(0, 4)?.map((image, index) => (
                <div
                    onClick={() => {
                        setOpenModal(true);
                    }}
                    key={index}
                    style={{
                        width: images?.length === 1 ? "500px" : "48%",
                        height: images?.length === 1 ? "250px" : "164px",
                        borderRadius: "8px",
                        overflow: "hidden",
                        marginBottom: "16px",
                        flexBasis: images?.length === 1 ? "auto" : "48%",
                        position: "relative",
                    }}
                >
                    <img
                        src={image.Photo}
                        alt={`Image1 ${index}`}
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "8px",
                            objectFit: "cover",
                        }}
                    />
                    {index === 3 && images.length > 4 && (
                        <div
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                background: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                borderRadius: "8px",
                                cursor: "pointer",
                            }}
                        >
                            <span
                                style={{
                                    color: "white",
                                    fontSize: "28px",
                                    fontFamily: "Lato",
                                    fontWeight: "700",
                                    marginBottom: "8px",
                                }}
                            >
                                + {images?.length - 4}
                            </span>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const Facilities = ({
    facilities,
    setShowMoreFacilities,
    displayedFacilities,
}) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                gap: "40px",
                flex: "1 0 0",
                flexWrap: "wrap",
            }}
        >
            {facilities
                ?.filter((m) => FACILITIES.has(m?.slug))
                ?.map((e, index) => {
                    return (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                width: "11%",
                                padding: "0px 8px",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "16px",
                            }}
                        >
                            <div
                                style={{
                                    width: "32px",
                                    height: "32px",
                                    position: "relative",
                                }}
                            >
                                <div
                                    style={{
                                        width: "28.82px",
                                        height: "20px",
                                        left: "1.59px",
                                        top: "6px",
                                        position: "absolute",
                                        // border: "1.50px #6275E7 solid",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: FACILITIES?.get(e?.slug),
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    color: "var(--Dark, #505573)",
                                    fontFamily: "Lato",
                                    fontSize: "15px",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                }}
                            >
                                {e?.facility_name}
                            </div>
                        </div>
                    );
                })}
            {facilities?.length > 0 &&
                facilities?.length - displayedFacilities?.length > 0 && (
                    <button
                        onClick={() => setShowMoreFacilities(true)}
                        className="btn"
                        style={{
                            textAlign: "center",
                            color: "#6275E7",
                            fontSize: "18px",
                            fontFamily: "Lato",
                            fontWeight: "700",
                            textDecoration: "underline",
                            wordWrap: "break-word",
                        }}
                    >
                        {`see
                        ${facilities?.length - displayedFacilities?.length}
                        more`}
                    </button>
                )}
        </div>
    );
};

const NoImages = () => {
    return (
        <>
            <div
                style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="500px"
                    height="250px"
                    viewBox="0 0 280 250"
                    fill="none"
                >
                    <path
                        d="M140.19 249.255C208.676 249.255 264.2 193.732 264.2 125C264.2 56.2688 208.432 0.745605 140.19 0.745605C71.7029 0.745605 16.1797 56.2688 16.1797 125C16.1797 193.732 71.7029 249.255 140.19 249.255Z"
                        fill="#EAEEF9"
                    />
                    <path
                        d="M71.9831 144.163C101.864 144.163 126.087 119.939 126.087 90.0583C126.087 60.1774 101.864 35.9541 71.9831 35.9541C42.1022 35.9541 17.8789 60.1774 17.8789 90.0583C17.8789 119.939 42.1022 144.163 71.9831 144.163Z"
                        fill="#EFF3FA"
                    />
                    <path
                        d="M269.709 149.432H12.8896L52.8706 95.7498L70.0153 72.9839L84.9818 89.2152L87.8627 92.3068L120.044 47.7587L133.816 28.7168L144.567 44.3859L181.175 97.7173L195.931 80.8536L203.449 72.211L209.843 79.8699L269.709 149.432Z"
                        fill="#D9E0EC"
                    />
                    <path
                        d="M70.0153 72.9844L69.3126 149.433H12.8896L52.8706 95.7503L70.0153 72.9844Z"
                        fill="#E8EDF8"
                    />
                    <path
                        d="M133.817 28.7168L131.498 141.422L87.8633 92.3068L133.817 28.7168Z"
                        fill="#E8EDF8"
                    />
                    <path
                        d="M204.785 138.401L181.176 97.7172L203.45 72.2109L204.785 138.401Z"
                        fill="#E8EDF8"
                    />
                    <path
                        d="M2.06934 149.433H69.3132H269.71H277.931"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M147.097 160.815H164.944"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M196.282 160.815H214.13"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M185.392 160.815H189.186"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M66.8535 160.815H130.795"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M39.8721 160.815H47.9526"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M245.258 160.815H267.743"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5.79297 160.815H27.6455"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M23.2188 170.301H93.8353"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M135.573 170.301H185.391"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M211.038 170.301H260.856"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M114.774 170.301H125.666"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M170.003 179.717H230.29"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M107.327 179.717H147.097"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M82.0312 179.717H93.8358"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M37.9746 179.717H64.043"
                        stroke="#CDD6E1"
                        stroke-width="3"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M95.8731 131.234C95.8731 135.66 92.2896 137.628 87.9331 137.628C83.5767 137.628 79.9932 135.66 79.9932 131.234C79.9932 126.807 87.9331 99.4736 87.9331 99.4736C87.9331 99.4736 95.8731 126.877 95.8731 131.234Z"
                        fill="white"
                    />
                    <path
                        d="M87.8633 123.505V148.59"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M87.8633 127.862L90.7442 125.262"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M87.8634 133.834L83.7178 128.915"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M167.263 129.266C167.263 134.185 163.257 136.363 158.409 136.363C153.491 136.363 149.556 134.185 149.556 129.266C149.556 124.348 158.409 93.9229 158.409 93.9229C158.409 93.9229 167.263 124.418 167.263 129.266Z"
                        fill="white"
                    />
                    <path
                        d="M158.409 120.624V148.589"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M158.409 125.542L161.571 122.591"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M158.409 132.217L153.771 126.667"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M196.072 136.785C196.072 139.806 193.613 141.141 190.661 141.141C187.64 141.141 185.251 139.806 185.251 136.785C185.251 133.763 190.661 115.143 190.661 115.143C190.661 115.143 196.072 133.763 196.072 136.785Z"
                        fill="white"
                    />
                    <path
                        d="M190.591 131.515V148.589"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M190.591 134.466L192.558 132.709"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M190.591 138.542L187.78 135.169"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M225.091 133.411C225.091 137.276 222 138.962 218.135 138.962C214.27 138.962 211.179 137.276 211.179 133.411C211.179 129.547 218.135 105.586 218.135 105.586C218.135 105.586 225.091 129.547 225.091 133.411Z"
                        fill="white"
                    />
                    <path
                        d="M218.135 126.596V148.589"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M218.135 130.391L220.594 128.142"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M218.135 135.661L214.481 131.304"
                        stroke="#B9C0D0"
                        stroke-width="2"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        opacity="0.8"
                        d="M88.4961 92.7289L76.4105 93.7829L70.7893 99.5446L64.0438 98.3501L52.8717 105.306L49.3584 100.739L70.2272 72.9844L88.4961 92.7289Z"
                        fill="white"
                    />
                    <path
                        opacity="0.6"
                        d="M150.048 52.3259L144.357 51.0611L138.525 53.8015L133.817 52.607L129.32 60.6172L122.294 57.3148L114.424 60.6172L113.089 57.5255L133.817 28.7168L150.048 52.3259Z"
                        fill="white"
                    />
                    <path
                        opacity="0.6"
                        d="M213.568 83.9452L207.665 88.5827L202.185 85.5613L194.456 90.0583L192.277 85.3505L203.731 72.2109L213.568 83.9452Z"
                        fill="white"
                    />
                    <path
                        d="M64.6756 52.1852C65.7998 51.9041 66.8538 51.8339 67.9781 51.8339C69.032 51.8339 70.1563 51.9041 71.2103 52.0447C72.2642 52.1852 73.3885 52.4663 74.4425 52.9581C75.4964 53.45 76.5504 54.1526 77.1828 55.3471L75.9883 55.0661L77.2531 54.0824C77.7449 53.8013 78.1665 53.45 78.5881 53.1689C79.5016 52.6068 80.4853 52.1149 81.5393 51.7636C82.5932 51.4123 83.6472 51.1312 84.7012 50.9907C85.8254 50.9204 86.8794 50.9204 88.0037 51.2015C88.2145 51.2718 88.2847 51.4826 88.2145 51.6231C88.1442 51.8339 88.0037 51.9041 87.7929 51.8339H87.7226C86.8091 51.6231 85.7552 51.6933 84.7715 51.8339C83.7877 51.9744 82.804 52.3257 81.8906 52.7473C80.9771 53.1689 80.1339 53.6608 79.2908 54.2229C78.8692 54.504 78.4476 54.8553 78.0963 55.1363L76.972 56.1201C76.6207 56.4011 76.1991 56.3309 75.918 56.0498L75.8478 56.1201L75.7775 55.9795C75.4964 55.2066 74.7235 54.5742 73.8803 54.1526C73.0372 53.731 72.0534 53.3797 70.9995 53.1689C70.0158 52.9581 68.9618 52.8176 67.9078 52.7473C66.8538 52.6771 65.7998 52.6771 64.8864 52.8879H64.8161C64.6053 52.9581 64.4648 52.8176 64.3945 52.6068C64.3945 52.396 64.4648 52.1852 64.6756 52.1852Z"
                        fill="#989FB0"
                    />
                    <path
                        d="M33.4783 71.4381C34.6026 71.1571 35.6566 71.0868 36.7808 71.0868C37.8348 71.0868 38.959 71.1571 40.013 71.2976C41.067 71.4381 42.1912 71.7192 43.2452 72.2111C44.2992 72.7029 45.3532 73.4056 45.9855 74.6001L44.791 74.319L46.0558 73.3353C46.5477 73.0542 46.9693 72.7029 47.3908 72.4218C48.3043 71.8597 49.288 71.3679 50.342 71.0165C51.396 70.6652 52.4499 70.3842 53.5039 70.2436C54.6282 70.1734 55.6821 70.1734 56.8064 70.4544C57.0172 70.5247 57.0874 70.7355 57.0172 70.876C56.9469 71.0868 56.8064 71.1571 56.5956 71.0868H56.5253C55.6119 70.876 54.5579 70.9463 53.5742 71.0868C52.5905 71.2273 51.6068 71.5787 50.6933 72.0003C49.7799 72.4218 48.9367 72.9137 48.0935 73.4758C47.6719 73.7569 47.2503 74.1082 46.899 74.3893L45.7747 75.373C45.4234 75.6541 45.0018 75.5838 44.7208 75.3027L44.6505 75.2325L44.5802 75.0919C44.2992 74.319 43.5263 73.6866 42.6831 73.265C41.8399 72.8434 40.8562 72.4921 39.8022 72.2813C38.8185 72.0705 37.7645 71.93 36.7105 71.8597C35.6565 71.7895 34.6026 71.7895 33.6891 72.0003H33.6189C33.4081 72.0705 33.2675 71.93 33.1973 71.7192C33.1973 71.6489 33.3378 71.4381 33.4783 71.4381Z"
                        fill="#989FB0"
                    />
                    <path
                        d="M72.2645 68.6979C73.3887 68.4168 74.4427 68.3466 75.5669 68.3466C76.6209 68.3466 77.7451 68.4168 78.7991 68.5574C79.8531 68.6979 80.9774 68.979 82.0313 69.4708C83.0853 69.9627 84.1393 70.6653 84.7717 71.8598L83.5772 71.5788L84.8419 70.5951C85.3338 70.314 85.7554 69.9627 86.177 69.6816C87.0904 69.1195 88.0741 68.6276 89.1281 68.2763C90.1821 67.925 91.2361 67.6439 92.29 67.5034C93.4143 67.4331 94.4683 67.4331 95.5925 67.7142C95.8033 67.7845 95.8736 67.9952 95.8033 68.1358C95.733 68.3466 95.5925 68.4168 95.3817 68.3466H95.3115C94.398 68.1358 93.344 68.206 92.3603 68.3466C91.3766 68.4871 90.3929 68.8384 89.4794 69.26C88.566 69.6816 87.7228 70.1735 86.8796 70.7356C86.458 71.0167 86.0364 71.368 85.6851 71.649L84.5609 72.6328C84.2096 72.9138 83.788 72.8436 83.5069 72.5625L83.4366 72.4922L83.3664 72.3517C83.0853 71.5788 82.3124 70.9464 81.4692 70.5248C80.626 70.1032 79.6423 69.7519 78.5883 69.5411C77.6046 69.3303 76.5506 69.1898 75.4967 69.1195C74.4427 69.0492 73.3887 69.0492 72.4753 69.26H72.405C72.1942 69.3303 72.0537 69.1898 71.9834 68.979C71.9834 68.9087 72.0537 68.6979 72.2645 68.6979Z"
                        fill="#989FB0"
                    />
                    <g filter="url(#filter0_d_166_1032)">
                        <path
                            d="M185.251 69.6588C185.251 73.7025 181.981 76.9727 177.902 76.9727C177.832 76.9727 177.234 76.9727 172.838 76.9727C169.779 76.9727 164.892 76.9727 157.085 76.9727H153.358C148.47 77.0782 144.567 73.1751 144.567 68.4632C144.567 63.7162 148.506 59.778 153.464 60.0241C157.718 46.7326 177.199 48.5962 178.851 62.3449C182.508 62.802 185.251 65.8963 185.251 69.6588Z"
                            fill="url(#paint0_linear_166_1032)"
                        />
                    </g>
                    <path
                        d="M177.902 76.9725C181.946 76.9725 185.251 73.7023 185.251 69.6586C185.251 65.6149 181.946 62.3447 177.902 62.3447C173.858 62.3447 170.553 65.6149 170.553 69.6586C170.553 73.7023 173.858 76.9725 177.902 76.9725Z"
                        fill="url(#paint1_linear_166_1032)"
                    />
                    <path
                        d="M165.911 77.0425C173.119 77.0425 178.991 71.2055 178.991 63.9971C178.991 56.7887 173.119 50.9517 165.911 50.9517C158.702 50.9517 152.83 56.7887 152.83 63.9971C152.83 71.2055 158.667 77.0425 165.911 77.0425Z"
                        fill="url(#paint2_linear_166_1032)"
                    />
                    <g filter="url(#filter1_d_166_1032)">
                        <path
                            d="M121.41 82.5249C121.41 85.5729 118.945 88.0379 115.871 88.0379C115.818 88.0379 115.367 88.0379 112.054 88.0379C109.748 88.0379 106.064 88.0379 100.18 88.0379H97.3704C93.6862 88.1174 90.7441 85.1753 90.7441 81.6237C90.7441 78.0455 93.7127 75.077 97.4499 75.2625C100.657 65.2437 115.341 66.6485 116.586 77.0119C119.343 77.3564 121.41 79.6888 121.41 82.5249Z"
                            fill="url(#paint3_linear_166_1032)"
                        />
                    </g>
                    <path
                        d="M115.871 88.0377C118.919 88.0377 121.41 85.5728 121.41 82.5247C121.41 79.4767 118.919 77.0117 115.871 77.0117C112.823 77.0117 110.331 79.4767 110.331 82.5247C110.331 85.5728 112.823 88.0377 115.871 88.0377Z"
                        fill="url(#paint4_linear_166_1032)"
                    />
                    <path
                        d="M106.832 88.0909C112.266 88.0909 116.692 83.6911 116.692 78.2576C116.692 72.8241 112.266 68.4243 106.832 68.4243C101.399 68.4243 96.9727 72.8241 96.9727 78.2576C96.9727 83.6911 101.372 88.0909 106.832 88.0909Z"
                        fill="url(#paint5_linear_166_1032)"
                    />
                    <defs>
                        <filter
                            id="filter0_d_166_1032"
                            x="122.567"
                            y="39.9839"
                            width="84.6836"
                            height="69.9907"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="11" />
                            <feGaussianBlur stdDeviation="11" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_166_1032"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_166_1032"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_d_166_1032"
                            x="68.7441"
                            y="57.4482"
                            width="74.666"
                            height="63.5913"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood
                                flood-opacity="0"
                                result="BackgroundImageFix"
                            />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            />
                            <feOffset dy="11" />
                            <feGaussianBlur stdDeviation="11" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_166_1032"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_166_1032"
                                result="shape"
                            />
                        </filter>
                        <linearGradient
                            id="paint0_linear_166_1032"
                            x1="164.909"
                            y1="61.7243"
                            x2="164.896"
                            y2="77.255"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="white" />
                            <stop offset="0.9964" stop-color="#ECF0F5" />
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear_166_1032"
                            x1="169.771"
                            y1="60.7701"
                            x2="176.286"
                            y2="67.8954"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#BCCBE1" />
                            <stop
                                offset="0.9942"
                                stop-color="white"
                                stop-opacity="0"
                            />
                        </linearGradient>
                        <linearGradient
                            id="paint2_linear_166_1032"
                            x1="151.605"
                            y1="58.0109"
                            x2="161.873"
                            y2="62.0291"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#E2E8F0" />
                            <stop
                                offset="0.9942"
                                stop-color="white"
                                stop-opacity="0"
                            />
                        </linearGradient>
                        <linearGradient
                            id="paint3_linear_166_1032"
                            x1="106.077"
                            y1="76.5441"
                            x2="106.067"
                            y2="88.2507"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="white" />
                            <stop offset="0.9964" stop-color="#ECF0F5" />
                        </linearGradient>
                        <linearGradient
                            id="paint4_linear_166_1032"
                            x1="109.742"
                            y1="75.8248"
                            x2="114.652"
                            y2="81.1956"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#BCCBE1" />
                            <stop
                                offset="0.9942"
                                stop-color="white"
                                stop-opacity="0"
                            />
                        </linearGradient>
                        <linearGradient
                            id="paint5_linear_166_1032"
                            x1="96.0494"
                            y1="73.7454"
                            x2="103.789"
                            y2="76.7742"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#E2E8F0" />
                            <stop
                                offset="0.9942"
                                stop-color="white"
                                stop-opacity="0"
                            />
                        </linearGradient>
                    </defs>
                </svg>
                <div
                    style={{
                        color: "#505573",
                        fontSize: "15px",
                        fontFamily: "Lato",
                        fontStyle: "italic",
                        fontWeight: "400",
                        wordWrap: "break-word",
                    }}
                >
                    No Images
                </div>
            </div>
        </>
    );
};

const AllFacilities = ({ facilities, open, handleClose }) => {
    return (
        <Modal
            show={open}
            onHide={handleClose}
            style={{ borderRadius: "16px", border: "none" }}
            dialogClassName="modal-facilities modal-dialog modal-dialog-centered"
        >
            <div
                style={{
                    width: "fit-content",
                    //height: "338px",
                    padding: "16px",
                    background: "#141933",
                    boxShadow:
                        "0px 24px 48px -12px rgba(15.96, 23.62, 40.04, 0.18)",
                    borderRadius: "6px",
                    overflow: "scroll",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        alignSelf: "stretch",
                        justifyContent: "space-between",
                        alignItems: "center",
                        display: "inline-flex",
                        borderBottom: "1px solid #878CA8",
                        paddingBottom: "16px",
                    }}
                >
                    <span
                        style={{
                            color: "#F5F6FA",
                            fontSize: "18px",
                            fontFamily: "Lato",
                            fontWeight: "700",
                            //lineHeight: 24,
                            // wordWrap: "break-word",
                        }}
                    >
                        Facilities
                    </span>
                    <button
                        className="btn"
                        onClick={handleClose}
                        style={{
                            padding: "0px",
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                        >
                            <path
                                d="M15 5L5 15M5 5L15 15"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div
                    style={{
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "8px",
                        display: "flex",
                        height: "338px",
                        overflow: "scroll",
                    }}
                >
                    <div
                        style={{
                            color: "#F5F6FA",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            //  lineHeight: 24,
                            wordWrap: "break-word",
                            width: "268px",
                        }}
                    >
                        {facilities?.map((e, index) => {
                            return (
                                <>
                                    {e?.facility_name}
                                    <br />
                                </>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

const ReportMappingError = ({ reportMappingError, handleClose }) => {
    return (
        <Modal
            show={reportMappingError}
            onHide={handleClose}
            dialogClassName="modal-33w modal-dialog modal-dialog-centered"
        >
            <div
                style={{
                    width: "592px",
                    padding: "24px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        color: "#141933",
                        fontSize: "20px",
                        fontFamily: "Lato",
                        fontWeight: "700",
                        lineHeight: "32px",
                        wordWrap: "break-word",
                    }}
                >
                    Report Error
                </div>
                <button
                    className="btn"
                    style={{ padding: "0px" }}
                    onClick={handleClose}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M18 6L6 18M6 6L18 18"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
            <div
                style={{
                    width: "589px",
                    height: "0px",
                    border: "1px #F5F6FA solid",
                }}
            ></div>
            <div
                style={{
                    width: "592px",
                    height: "268px",
                    paddingLeft: "24px",
                    paddingRight: "24px",
                    paddingTop: "32px",
                    paddingBottom: "32px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "32px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        gap: "24px",
                        display: "flex",
                    }}
                >
                    <div
                        style={{
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "13px",
                            display: "inline-flex",
                        }}
                    >
                        <input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                position: "relative",
                                background: "white",
                                borderRadius: "4px",
                                border: "1px #878CA8 solid",
                            }}
                        />
                        <div
                            style={{
                                textAlign: "center",
                                color: "#141933",
                                fontSize: "18px",
                                fontFamily: "Lato",
                                fontWeight: "400",
                                lineHeight: "24px",
                                wordWrap: "break-word",
                            }}
                        >
                            The displayed informations are inaccurate with the
                            hotel's details
                        </div>
                    </div>
                    <div
                        style={{
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "13px",
                            display: "inline-flex",
                        }}
                    >
                        <input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                position: "relative",
                                background: "white",
                                borderRadius: "4px",
                                border: "1px #878CA8 solid",
                            }}
                        />
                        <div
                            style={{
                                textAlign: "center",
                                color: "#141933",
                                fontSize: "18px",
                                fontFamily: "Lato",
                                fontWeight: "400",
                                lineHeight: "24px",
                                wordWrap: "break-word",
                            }}
                        >
                            The hotel shown does not match with the hotel in my
                            records
                        </div>
                    </div>
                </div>
                <textarea
                    rows="5"
                    style={{
                        color: "#878CA8",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        alignSelf: "stretch",
                        height: "100px",
                        padding: "12px",
                        background: "white",
                        borderRadius: "8px",
                        overflow: "hidden",
                        border: "1px #DADEF2 solid",
                        alignItems: "flex-start",
                        gap: "2px",
                        display: "inline-flex",
                    }}
                    placeholder="Additional notes"
                />
            </div>
            <div
                style={{
                    width: "589px",
                    height: "0px",
                    border: "1px #F5F6FA solid",
                }}
            ></div>
            <div
                style={{
                    width: "592px",
                    height: "102px",
                    padding: "24px",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <button
                    className="btn btn-primary"
                    style={{
                        paddingLeft: "24px",
                        paddingRight: "24px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        background:
                            "linear-gradient(0deg, #6275E7 0%, #6275E7 100%), linear-gradient(0deg,  0%,  100%)",
                        borderRadius: "8px",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "16px",
                        display: "flex",
                        height: "56px",
                    }}
                >
                    <div
                        style={{
                            color: "white",
                            fontSize: "18px",
                            fontFamily: "Lato",
                            fontWeight: "500",
                            wordWrap: "break-word",
                        }}
                    >
                        Submit
                    </div>
                </button>
                <button
                    onClick={handleClose}
                    style={{
                        paddingLeft: "24px",
                        paddingRight: "24px",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        borderRadius: "8px",
                        border: "1px #878CA8 solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "16px",
                        display: "flex",
                        height: "56px",
                    }}
                >
                    <div
                        style={{
                            color: "#141933",
                            fontSize: "18px",
                            fontFamily: "Lato",
                            fontWeight: "500",
                            wordWrap: "break-word",
                        }}
                    >
                        Cancel
                    </div>
                </button>
            </div>
        </Modal>
    );
};

const CarousalIcon = ({ left }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            style={{ transform: left ? "rotate(180deg)" : "rotate(0deg)" }}
        >
            <g filter="url(#filter0_dd_22_3722)">
                <path
                    d="M30 36L18 24L30 12"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dd_22_3722"
                    x="13"
                    y="8"
                    width="22"
                    height="34"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_22_3722"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_22_3722"
                        result="effect2_dropShadow_22_3722"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_22_3722"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

const DisplayCarouselImages = ({ images, open, handleClose, image }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const handlePrevious = () => {
        setSelectedImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setSelectedImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };
    return (
        <Modal
            show={open}
            onHide={handleClose}
            style={{ borderRadius: "16px", border: "none" }}
            dialogClassName="modal-carousal modal-dialog modal-dialog-centered"
        >
            <div
                style={{
                    width: "990px",
                    height: "626px",
                    position: "relative",
                    background: "white",
                    borderRadius: "16px",
                }}
            >
                <Carousel
                    infiniteLoop={false}
                    showThumbs={false}
                    autoFocus={false}
                    showArrows={false} // Hide the default arrows
                    selectedItem={selectedImageIndex} // Select the image based on index
                    onChange={(index) => setSelectedImageIndex(index)}
                >
                    {images?.map((e, index) => (
                        <div key={index}>
                            <img
                                style={{
                                    width: "100%", // Adjusted width to fit the container
                                    height: "626px",
                                    objectFit: "cover", // Maintain aspect ratio and fill the space
                                    borderRadius: "16px",
                                }}
                                src={e?.[image]}
                                alt={`Imagex ${index}`}
                            />
                        </div>
                    ))}
                </Carousel>
                {/* Custom navigation buttons */}
                <div
                    style={{
                        padding: "8px",
                        left: "20px", // Adjusted left position
                        top: "50%", // Adjusted top position
                        transform: "translateY(-50%)", // Center vertically
                        position: "absolute",
                        background: "rgba(20, 40, 51, 0.80)",
                        borderRadius: "45px",
                        justifyContent: "center", // Center horizontally
                        alignItems: "center", // Center vertically
                        display: "flex",
                        cursor: "pointer", // Added cursor style
                    }}
                    onClick={handlePrevious}
                >
                    {/* Your left arrow */}
                    <CarousalIcon left={false} />
                </div>
                <div
                    style={{
                        padding: "8px",
                        right: "20px", // Adjusted right position
                        top: "50%", // Adjusted top position
                        transform: "translateY(-50%)", // Center vertically
                        position: "absolute",
                        background: "rgba(20, 40, 51, 0.80)",
                        borderRadius: "45px",
                        justifyContent: "center", // Center horizontally
                        alignItems: "center", // Center vertically
                        display: "flex",
                        cursor: "pointer", // Added cursor style
                    }}
                    onClick={handleNext}
                >
                    {/* Your right arrow */}
                    <CarousalIcon left={true} />
                </div>
            </div>
        </Modal>
    );
};

const PoliciesList = ({ policies }) => {
    return (
        <div
            style={{
                width: "100%",
                // height: "406px",
                paddingTop: "24px",
                paddingBottom: "24px",
                background: "white",
                borderRadius: "16px",
                border: "1px #DADEF2 solid",
                justifyContent: "center",
                alignItems: "flex-start",
                display: "inline-flex",
            }}
        >
            <div
                style={{
                    flex: "1 1 0",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "12px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        position: "relative",
                    }}
                >
                    <ChildrenIcon />
                </div>
                <div
                    style={{
                        color: "#141933",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                    }}
                >
                    Children
                </div>
                {policies?.find((e) => e.name === "Children") ? (
                    <div
                        style={{
                            alignSelf: "stretch",
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        {policies?.find((e) => e.name === "Children")?.content}
                    </div>
                ) : (
                    <div
                        style={{
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontStyle: "italic",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        No data
                    </div>
                )}
            </div>
            <div
                style={{
                    width: "0px",
                    alignSelf: "stretch",
                    border: "1px #DADEF2 solid",
                }}
            ></div>
            <div
                style={{
                    flex: "1 1 0",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "12px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        position: "relative",
                    }}
                >
                    <PetsIcon />
                </div>
                <div
                    style={{
                        color: "#141933",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                    }}
                >
                    Pets
                </div>
                {policies?.find((e) => e.name === "Pets") ? (
                    <div
                        style={{
                            alignSelf: "stretch",
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        {policies?.find((e) => e.name === "Pets")?.content}
                    </div>
                ) : (
                    <div
                        style={{
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontStyle: "italic",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        No data
                    </div>
                )}
            </div>
            <div
                style={{
                    width: "0px",
                    alignSelf: "stretch",
                    border: "1px #DADEF2 solid",
                }}
            ></div>
            <div
                style={{
                    flex: "1 1 0",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "12px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        position: "relative",
                    }}
                >
                    <GroupIcon />
                </div>
                <div
                    style={{
                        color: "#141933",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                    }}
                >
                    Group
                </div>
                {policies?.find((e) => e.name === "Group") ? (
                    <div
                        style={{
                            alignSelf: "stretch",
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        {policies?.find((e) => e.name === "Group")?.content}
                    </div>
                ) : (
                    <div
                        style={{
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontStyle: "italic",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        No data
                    </div>
                )}
            </div>
            <div
                style={{
                    width: "0px",
                    alignSelf: "stretch",
                    border: "1px #DADEF2 solid",
                }}
            ></div>
            <div
                style={{
                    flex: "1 1 0",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "12px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        width: "32px",
                        height: "32px",
                        position: "relative",
                    }}
                >
                    <ParkingIcon />
                </div>
                <div
                    style={{
                        color: "#141933",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                    }}
                >
                    Parking
                </div>
                {policies?.find((e) => e.name === "Parking") ? (
                    <div
                        style={{
                            alignSelf: "stretch",
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        {policies?.find((e) => e.name === "Parking")?.content}
                    </div>
                ) : (
                    <div
                        style={{
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontStyle: "italic",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        No data
                    </div>
                )}
            </div>
            <div
                style={{
                    width: "0px",
                    alignSelf: "stretch",
                    border: "1px #DADEF2 solid",
                }}
            ></div>
            <div
                style={{
                    flex: "1 1 0",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "12px",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "16px",
                    display: "inline-flex",
                }}
            >
                <div
                    style={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "8px",
                        display: "inline-flex",
                    }}
                >
                    <div
                        style={{
                            width: "32px",
                            height: "32px",
                            position: "relative",
                        }}
                    >
                        <WifiIcon />
                    </div>
                </div>
                <div
                    style={{
                        color: "#141933",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                        lineHeight: "24px",
                        wordWrap: "break-word",
                    }}
                >
                    Internet
                </div>
                {policies?.find((e) => e.name === "Internet") ? (
                    <div
                        style={{
                            alignSelf: "stretch",
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        {policies?.find((e) => e.name === "Internet")?.content}
                    </div>
                ) : (
                    <div
                        style={{
                            color: "#505573",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontStyle: "italic",
                            fontWeight: "400",
                            wordWrap: "break-word",
                        }}
                    >
                        No data
                    </div>
                )}
            </div>
        </div>
    );
};

const ChildrenIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                d="M12.4007 15.25C11.9865 15.25 11.6507 15.5858 11.6507 16C11.6507 16.4142 11.9865 16.75 12.4007 16.75V15.25ZM12.4141 16.75C12.8283 16.75 13.1641 16.4142 13.1641 16C13.1641 15.5858 12.8283 15.25 12.4141 15.25V16.75ZM20.4007 15.25C19.9865 15.25 19.6507 15.5858 19.6507 16C19.6507 16.4142 19.9865 16.75 20.4007 16.75V15.25ZM20.4141 16.75C20.8283 16.75 21.1641 16.4142 21.1641 16C21.1641 15.5858 20.8283 15.25 20.4141 15.25V16.75ZM14.1199 20.6902C13.7647 20.4771 13.304 20.5923 13.0909 20.9475C12.8778 21.3026 12.993 21.7633 13.3482 21.9765L14.1199 20.6902ZM19.4533 21.9765C19.8084 21.7633 19.9236 21.3026 19.7105 20.9475C19.4974 20.5923 19.0367 20.4771 18.6815 20.6902L19.4533 21.9765ZM26.3203 7.93229C26.062 7.60848 25.5901 7.55539 25.2663 7.8137C24.9425 8.07201 24.8894 8.54391 25.1478 8.86771L26.3203 7.93229ZM28.134 13.6L27.3978 13.7427C27.4427 13.9747 27.5944 14.172 27.8071 14.275L28.134 13.6ZM28.134 18.4L27.8071 17.725C27.5991 17.8257 27.4492 18.0168 27.4007 18.2428L28.134 18.4ZM4.66738 18.4L5.40071 18.2428C5.35226 18.0168 5.20231 17.8257 4.9943 17.725L4.66738 18.4ZM3.16309 16H3.91309H3.16309ZM4.66738 13.6L4.9943 14.275C5.20465 14.1731 5.35548 13.979 5.40223 13.75L4.66738 13.6ZM16.4007 4V3.25L16.3992 3.25L16.4007 4ZM17.1507 9.33333C17.1507 8.91912 16.8149 8.58333 16.4007 8.58333C15.9865 8.58333 15.6507 8.91912 15.6507 9.33333H17.1507ZM12.4007 16.75H12.4141V15.25H12.4007V16.75ZM20.4007 16.75H20.4141V15.25H20.4007V16.75ZM13.3482 21.9765C14.1457 22.455 15.2158 22.75 16.4007 22.75V21.25C15.4523 21.25 14.6558 21.0117 14.1199 20.6902L13.3482 21.9765ZM16.4007 22.75C17.5856 22.75 18.6558 22.455 19.4533 21.9765L18.6815 20.6902C18.1457 21.0117 17.3491 21.25 16.4007 21.25V22.75ZM25.1478 8.86771C26.2802 10.2873 27.0522 11.9599 27.3978 13.7427L28.8703 13.4573C28.4787 11.4368 27.6038 9.54115 26.3203 7.93229L25.1478 8.86771ZM27.8071 14.275C28.1312 14.4319 28.4045 14.677 28.5957 14.9821L29.8667 14.1854C29.5258 13.6416 29.0386 13.2048 28.461 12.925L27.8071 14.275ZM28.5957 14.9821C28.7869 15.2872 28.8883 15.6399 28.8883 16H30.3883C30.3883 15.3582 30.2075 14.7293 29.8667 14.1854L28.5957 14.9821ZM28.8883 16C28.8883 16.3601 28.7869 16.7128 28.5957 17.0179L29.8667 17.8146C30.2075 17.2707 30.3883 16.6418 30.3883 16H28.8883ZM28.5957 17.0179C28.4045 17.323 28.1312 17.5681 27.8071 17.725L28.461 19.075C29.0386 18.7952 29.5258 18.3584 29.8667 17.8146L28.5957 17.0179ZM27.4007 18.2428C26.8611 20.7596 25.4747 23.0153 23.4728 24.6334L24.4158 25.8C26.6845 23.9661 28.2558 21.4097 28.8674 18.5572L27.4007 18.2428ZM23.4728 24.6334C21.471 26.2516 18.9748 27.1343 16.4007 27.1343V28.6343C19.318 28.6343 22.147 27.6339 24.4158 25.8L23.4728 24.6334ZM16.4007 27.1343C13.8267 27.1343 11.3305 26.2516 9.3286 24.6334L8.38566 25.8C10.6544 27.6339 13.4835 28.6343 16.4007 28.6343V27.1343ZM9.3286 24.6334C7.32676 23.0153 5.94035 20.7596 5.40071 18.2428L3.93405 18.5572C4.54563 21.4097 6.1169 23.9661 8.38566 25.8L9.3286 24.6334ZM4.9943 17.725C4.67024 17.5681 4.39695 17.323 4.20573 17.0179L2.93476 17.8146C3.27563 18.3584 3.7628 18.7952 4.34046 19.075L4.9943 17.725ZM4.20573 17.0179C4.01451 16.7128 3.91309 16.3601 3.91309 16H2.41309C2.41309 16.6418 2.59388 17.2707 2.93476 17.8146L4.20573 17.0179ZM3.91309 16C3.91309 15.6399 4.01451 15.2872 4.20573 14.9821L2.93476 14.1854C2.59388 14.7293 2.41309 15.3582 2.41309 16H3.91309ZM4.20573 14.9821C4.39695 14.677 4.67024 14.4319 4.9943 14.275L4.34046 12.925C3.7628 13.2048 3.27563 13.6416 2.93476 14.1854L4.20573 14.9821ZM5.40223 13.75C5.92006 11.2131 7.29709 8.93252 9.30101 7.29296L8.35115 6.13202C6.08005 7.9902 4.51941 10.5749 3.93253 13.45L5.40223 13.75ZM9.30101 7.29296C11.3049 5.65339 13.8131 4.75522 16.4022 4.75L16.3992 3.25C13.4648 3.25592 10.6223 4.27384 8.35115 6.13202L9.30101 7.29296ZM16.4007 4.75C17.6029 4.75 18.6098 5.08138 19.2958 5.57532C19.9781 6.06655 20.3174 6.69146 20.3174 7.33333H21.8174C21.8174 6.10854 21.1567 5.06678 20.1723 4.35802C19.1916 3.65195 17.8652 3.25 16.4007 3.25V4.75ZM20.3174 7.33333C20.3174 8.94534 19.3099 9.91667 18.4007 9.91667V11.4167C20.4249 11.4167 21.8174 9.45466 21.8174 7.33333H20.3174ZM18.4007 9.91667C17.9817 9.91667 17.6278 9.8101 17.4034 9.66725C17.1836 9.52739 17.1507 9.40419 17.1507 9.33333H15.6507C15.6507 10.0625 16.0845 10.6059 16.5981 10.9327C17.1069 11.2566 17.7531 11.4167 18.4007 11.4167V9.91667Z"
                fill="#6275E7"
            />
        </svg>
    );
};

const PetsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                d="M12.7835 6.89598C12.7835 7.3102 13.1193 7.64598 13.5335 7.64598C13.9477 7.64598 14.2835 7.3102 14.2835 6.89598H12.7835ZM8.86684 3.99999L8.99001 4.7398L8.99032 4.73975L8.86684 3.99999ZM3.5335 13.3333L2.7883 13.418L2.78831 13.4181L3.5335 13.3333ZM8.40817 14.6667L8.67084 15.3692L8.67109 15.3691L8.40817 14.6667ZM12.2379 11.5909C12.3801 11.2019 12.1801 10.7712 11.7911 10.6289C11.4021 10.4867 10.9714 10.6867 10.8291 11.0757L12.2379 11.5909ZM18.473 6.89598C18.473 7.3102 18.8088 7.64598 19.223 7.64598C19.6372 7.64598 19.973 7.3102 19.973 6.89598H18.473ZM23.8896 3.99999L23.7662 4.73975L23.7665 4.7398L23.8896 3.99999ZM29.223 13.3333L29.9682 13.4181L29.9682 13.418L29.223 13.3333ZM24.3483 14.6667L24.0854 15.3691L24.0857 15.3692L24.3483 14.6667ZM22.0674 11.0757C21.9251 10.6867 21.4944 10.4867 21.1054 10.6289C20.7164 10.7712 20.5163 11.2019 20.6586 11.5909L22.0674 11.0757ZM11.6169 18.6667C11.6169 18.2525 11.2811 17.9167 10.8669 17.9167C10.4526 17.9167 10.1169 18.2525 10.1169 18.6667H11.6169ZM10.1169 19.3333C10.1169 19.7475 10.4526 20.0833 10.8669 20.0833C11.2811 20.0833 11.6169 19.7475 11.6169 19.3333H10.1169ZM22.2835 18.6667C22.2835 18.2525 21.9477 17.9167 21.5335 17.9167C21.1193 17.9167 20.7835 18.2525 20.7835 18.6667H22.2835ZM20.7835 19.3333C20.7835 19.7475 21.1193 20.0833 21.5335 20.0833C21.9477 20.0833 22.2835 19.7475 22.2835 19.3333H20.7835ZM15.2002 21.6667V20.9167C14.8968 20.9167 14.6234 21.0994 14.5073 21.3797C14.3912 21.6599 14.4554 21.9825 14.6699 22.197L15.2002 21.6667ZM17.2002 21.6667L17.7305 22.197C17.945 21.9825 18.0092 21.6599 17.8931 21.3797C17.777 21.0994 17.5035 20.9167 17.2002 20.9167V21.6667ZM16.2002 22.6667L15.6699 23.197C15.9628 23.4899 16.4376 23.4899 16.7305 23.197L16.2002 22.6667ZM6.81958 15.184C6.92343 14.783 6.68255 14.3738 6.28156 14.2699C5.88057 14.1661 5.47133 14.407 5.36749 14.808L6.81958 15.184ZM5.53354 19.408H6.28354L6.28354 19.4073L5.53354 19.408ZM26.9282 14.7815C26.8097 14.3846 26.3919 14.1589 25.995 14.2773C25.5981 14.3958 25.3724 14.8136 25.4909 15.2105L26.9282 14.7815ZM13.741 6.15073C13.3345 6.23058 13.0698 6.6248 13.1496 7.03125C13.2295 7.43769 13.6237 7.70245 14.0301 7.62259L13.741 6.15073ZM16.2002 6.66666L16.1968 7.41666H16.2002V6.66666ZM18.8663 7.79312C19.2631 7.91198 19.6811 7.68667 19.8 7.28987C19.9189 6.89308 19.6935 6.47506 19.2967 6.3562L18.8663 7.79312ZM14.2835 6.89598C14.2835 5.665 13.5832 4.61699 12.5682 3.96224C11.5521 3.30676 10.1936 3.01814 8.74335 3.26022L8.99032 4.73975C10.1041 4.55383 11.0789 4.78654 11.7551 5.22273C12.4324 5.65964 12.7835 6.27364 12.7835 6.89598H14.2835ZM8.74367 3.26017C7.56879 3.45577 6.6107 4.16878 5.85556 5.0475C5.09912 5.92773 4.49964 7.0266 4.04117 8.11306C3.58083 9.20396 3.24949 10.3138 3.04209 11.2401C2.84274 12.1304 2.73506 12.9496 2.7883 13.418L4.2787 13.2486C4.25662 13.0543 4.30743 12.4539 4.50584 11.5679C4.69618 10.7178 5.00184 9.69468 5.42317 8.69624C5.84636 7.69337 6.37322 6.74657 6.9932 6.02514C7.61447 5.30219 8.28289 4.85753 8.99001 4.7398L8.74367 3.26017ZM2.78831 13.4181C2.84331 13.9014 3.13972 14.315 3.46561 14.62C3.80716 14.9397 4.25873 15.2154 4.77839 15.4134C5.82365 15.8115 7.20411 15.9176 8.67084 15.3692L8.14551 13.9642C7.03756 14.3784 6.03403 14.2865 5.31228 14.0116C4.94844 13.873 4.67077 13.6935 4.49061 13.5249C4.29479 13.3416 4.27703 13.2339 4.27869 13.2485L2.78831 13.4181ZM8.67109 15.3691C10.6177 14.6404 11.6761 13.1272 12.2379 11.5909L10.8291 11.0757C10.367 12.3395 9.56127 13.4342 8.14526 13.9642L8.67109 15.3691ZM19.973 6.89598C19.973 6.27364 20.3241 5.65964 21.0014 5.22273C21.6776 4.78654 22.6524 4.55383 23.7662 4.73975L24.0131 3.26022C22.5629 3.01814 21.2044 3.30676 20.1883 3.96224C19.1732 4.61699 18.473 5.665 18.473 6.89598H19.973ZM23.7665 4.7398C24.4736 4.85753 25.142 5.30219 25.7633 6.02514C26.3833 6.74657 26.9101 7.69337 27.3333 8.69624C27.7546 9.69468 28.0603 10.7178 28.2506 11.5679C28.4491 12.4539 28.4999 13.0543 28.4778 13.2486L29.9682 13.418C30.0214 12.9496 29.9137 12.1304 29.7144 11.2401C29.507 10.3138 29.1757 9.20396 28.7153 8.11306C28.2568 7.0266 27.6574 5.92773 26.9009 5.0475C26.1458 4.16878 25.1877 3.45577 24.0128 3.26017L23.7665 4.7398ZM28.4778 13.2485C28.4795 13.2339 28.4617 13.3416 28.2659 13.5249C28.0857 13.6935 27.808 13.873 27.4442 14.0116C26.7225 14.2865 25.7189 14.3784 24.611 13.9642L24.0857 15.3692C25.5524 15.9176 26.9328 15.8115 27.9781 15.4134C28.4978 15.2154 28.9493 14.9397 29.2909 14.62C29.6168 14.315 29.9132 13.9014 29.9682 13.4181L28.4778 13.2485ZM24.6112 13.9642C23.2251 13.4454 22.5451 12.3821 22.0674 11.0757L20.6586 11.5909C21.2048 13.0845 22.1089 14.6292 24.0854 15.3691L24.6112 13.9642ZM10.1169 18.6667V19.3333H11.6169V18.6667H10.1169ZM20.7835 18.6667V19.3333H22.2835V18.6667H20.7835ZM15.2002 22.4167H17.2002V20.9167H15.2002V22.4167ZM16.6699 21.1363L15.6699 22.1363L16.7305 23.197L17.7305 22.197L16.6699 21.1363ZM16.7305 22.1363L15.7305 21.1363L14.6699 22.197L15.6699 23.197L16.7305 22.1363ZM5.36749 14.808C4.97837 16.3105 4.78214 17.8565 4.78354 19.4087L6.28354 19.4073C6.28226 17.9825 6.46239 16.5633 6.81958 15.184L5.36749 14.808ZM4.78354 19.408C4.78354 22.4314 6.09349 24.7988 8.20689 26.3893C10.2987 27.9634 13.1365 28.75 16.2002 28.75V27.25C13.3732 27.25 10.8777 26.5219 9.10885 25.1907C7.36158 23.8758 6.28354 21.9472 6.28354 19.408H4.78354ZM16.2002 28.75C19.2639 28.75 22.1017 27.9634 24.1935 26.3893C26.3069 24.7988 27.6169 22.4314 27.6169 19.408H26.1169C26.1169 21.9472 25.0388 23.8758 23.2916 25.1907C21.5227 26.5219 19.0272 27.25 16.2002 27.25V28.75ZM27.6169 19.408C27.6169 17.9195 27.39 16.3286 26.9282 14.7815L25.4909 15.2105C25.9118 16.6207 26.1169 18.0672 26.1169 19.408H27.6169ZM14.0301 7.62259C14.7438 7.48239 15.4696 7.4134 16.1968 7.41665L16.2036 5.91667C15.377 5.91297 14.552 5.99138 13.741 6.15073L14.0301 7.62259ZM16.2002 7.41666C17.1702 7.41666 18.0575 7.55084 18.8663 7.79312L19.2967 6.3562C18.3429 6.07048 17.3102 5.91666 16.2002 5.91666V7.41666Z"
                fill="#6275E7"
            />
        </svg>
    );
};

const GroupIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                d="M29.3337 28V25.3333C29.3337 22.8482 27.634 20.7601 25.3337 20.168M20.667 4.38768C22.6215 5.17886 24.0003 7.09508 24.0003 9.33333C24.0003 11.5716 22.6215 13.4878 20.667 14.279M22.667 28C22.667 25.515 22.667 24.2725 22.261 23.2924C21.7197 21.9855 20.6815 20.9473 19.3746 20.406C18.3945 20 17.152 20 14.667 20H10.667C8.18197 20 6.93946 20 5.95935 20.406C4.65253 20.9473 3.61427 21.9855 3.07297 23.2924C2.66699 24.2725 2.66699 25.515 2.66699 28M18.0003 9.33333C18.0003 12.2789 15.6125 14.6667 12.667 14.6667C9.72147 14.6667 7.33366 12.2789 7.33366 9.33333C7.33366 6.38781 9.72147 4 12.667 4C15.6125 4 18.0003 6.38781 18.0003 9.33333Z"
                stroke="#6275E7"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

const ParkingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                d="M12.0511 22.6665C12.0511 23.0807 12.3869 23.4165 12.8011 23.4165C13.2153 23.4165 13.5511 23.0807 13.5511 22.6665H12.0511ZM12.8011 9.33317V8.58317C12.3869 8.58317 12.0511 8.91896 12.0511 9.33317H12.8011ZM12.8011 16.5832C12.3869 16.5832 12.0511 16.919 12.0511 17.3332C12.0511 17.7474 12.3869 18.0832 12.8011 18.0832V16.5832ZM29.3844 15.9998C29.3844 22.9494 23.7507 28.5832 16.8011 28.5832V30.0832C24.5791 30.0832 30.8844 23.7778 30.8844 15.9998H29.3844ZM16.8011 28.5832C9.85152 28.5832 4.21777 22.9494 4.21777 15.9998H2.71777C2.71777 23.7778 9.0231 30.0832 16.8011 30.0832V28.5832ZM4.21777 15.9998C4.21777 9.05025 9.85152 3.4165 16.8011 3.4165V1.9165C9.0231 1.9165 2.71777 8.22183 2.71777 15.9998H4.21777ZM16.8011 3.4165C23.7507 3.4165 29.3844 9.05025 29.3844 15.9998H30.8844C30.8844 8.22183 24.5791 1.9165 16.8011 1.9165V3.4165ZM13.5511 22.6665V9.33317H12.0511V22.6665H13.5511ZM12.8011 10.0832H18.1344V8.58317H12.8011V10.0832ZM18.1344 10.0832C18.9964 10.0832 19.823 10.4256 20.4325 11.0351L21.4932 9.97441C20.6024 9.08362 19.3942 8.58317 18.1344 8.58317V10.0832ZM20.4325 11.0351C21.042 11.6446 21.3844 12.4712 21.3844 13.3332H22.8844C22.8844 12.0734 22.384 10.8652 21.4932 9.97441L20.4325 11.0351ZM21.3844 13.3332C21.3844 14.1951 21.042 15.0218 20.4325 15.6313L21.4932 16.6919C22.384 15.8011 22.8844 14.5929 22.8844 13.3332H21.3844ZM20.4325 15.6313C19.823 16.2408 18.9964 16.5832 18.1344 16.5832V18.0832C19.3942 18.0832 20.6024 17.5827 21.4932 16.6919L20.4325 15.6313ZM18.1344 16.5832H12.8011V18.0832H18.1344V16.5832Z"
                fill="#6275E7"
            />
        </svg>
    );
};

const WifiIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
        >
            <path
                d="M16.6003 26H16.6136M31.0088 11.601C27.213 8.12265 22.1544 6 16.6001 6C11.0458 6 5.98724 8.12265 2.19141 11.601M6.9095 16.324C9.49367 14.0475 12.8857 12.6667 16.6002 12.6667C20.3148 12.6667 23.7068 14.0475 26.291 16.324M21.5314 21.0335C20.1726 19.9684 18.4605 19.3333 16.6001 19.3333C14.7116 19.3333 12.9759 19.9877 11.6074 21.0821"
                stroke="#6275E7"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};
function compareByID(a, b) {
    return a.room_facilities_id - b.room_facilities_id;
}

const DisplayRooms = ({
    data,
    setCurrentRoomImages,
    renderTooltip,
    setOpenModalRooms,
}) => {
    const columns = [
        {
            name: (
                <div
                    style={{
                        width: "200px",
                        color: "#878CA8",
                        fontSize: "15px",
                        fontFamily: "Lato",
                        fontWeight: "700",
                        wordWrap: "break-word",
                    }}
                >
                    Room Name
                </div>
            ),
            cell: (e) => {
                return (
                    <div
                        style={{
                            flex: "1 1 0",
                            color: "#141933",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "700",
                            wordWrap: "break-word",
                        }}
                    >
                        {e?.room_name}
                    </div>
                );
            },
            minWidth: "50%",
            sortable: false,
        },
        {
            name: (
                <div
                    style={{
                        width: "200px",
                        color: "#878CA8",
                        fontSize: "15px",
                        fontFamily: "Lato",
                        fontWeight: "700",
                        wordWrap: "break-word",
                    }}
                >
                    Capacity
                </div>
            ),
            // selector: (e) => e?.max_occupancy,
            cell: (e) => {
                return (
                    <div
                        style={{
                            width: "100px",
                            color: "#878CA8",
                            fontSize: "15px",
                            fontFamily: "Lato",
                            fontWeight: "700",
                            wordWrap: "break-word",
                        }}
                    >
                        {e?.max_occupancy}
                    </div>
                );
            },
            minWidth: "10%",
            sortable: false,
        },
        {
            name: (
                <div
                    style={{
                        width: "200px",
                        color: "#878CA8",
                        fontSize: "15px",
                        fontFamily: "Lato",
                        fontWeight: "700",
                        wordWrap: "break-word",
                    }}
                >
                    Popular Amenities
                </div>
            ),
            cell: (e) => {
                return (
                    <div
                        style={{
                            height: "20px",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: "20px",
                            display: "flex",
                        }}
                    >
                        {data?.["Room amenities"]
                            ?.sort(compareByID)
                            ?.filter(
                                (m) =>
                                    m.room_id === e.id &&
                                    AMENITIES.has(m.room_facilities_id)
                            )
                            ?.map((am, i) => {
                                return (
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{
                                            show: 100,
                                            hide: 200,
                                        }}
                                        overlay={renderTooltip(
                                            am.facility_name
                                        )}
                                    >
                                        <div
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                position: "relative",
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: AMENITIES.get(
                                                    am.room_facilities_id
                                                ),
                                            }}
                                        />
                                    </OverlayTrigger>
                                );
                            })}
                    </div>
                );
            },
            minWidth: "16%",
            sortable: false,
        },
        {
            name: <div className="table-title"></div>,
            cell: (e, index) => {
                return (
                    <div style={{ padding: "16px" }}>
                        {data?.["Room photo"]?.find(
                            (element) => element.room_id === e?.id
                        )?.link && (
                            <img
                                onClick={() => {
                                    setCurrentRoomImages(
                                        data?.["Room photo"]?.filter(
                                            (element) =>
                                                element.room_id === e?.id
                                        )
                                    );
                                    setOpenModalRooms(true);
                                }}
                                style={{
                                    width: "80px",
                                    height: "55px",
                                    position: "relative",
                                    borderRadius: "4px",
                                    border: "0.50px #878CA8 solid",
                                    cursor: "pointer",
                                }}
                                alt={`Room Images ${index}`}
                                src={
                                    data?.["Room photo"]?.find(
                                        (element) => element.room_id === e?.id
                                    )?.link
                                }
                            />
                        )}
                    </div>
                );
            },
            minWidth: "20%",
            sortable: false,
        },
    ];
    const totalRooms = removeDuplicateRooms(data?.Room)?.length ?? 0;

    return (
        <div
            style={{
                width: "100%",
                //height: 642,
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "16px",
                display: "inline-flex",
                paddingTop: "80px",
            }}
        >
            <div>
                <span
                    style={{
                        color: "#141933",
                        fontSize: "28px",
                        fontFamily: "Lato",
                        fontWeight: "700",
                        lineHeight: "40px",
                        wordWrap: "break-word",
                    }}
                >
                    Rooms&nbsp;
                </span>
            </div>
            <div
                style={{
                    color: "#141933",
                    fontSize: "15px",
                    fontFamily: "Lato",
                    fontWeight: "700",
                    wordWrap: "break-word",
                }}
            >
                {separator(totalRooms)} Results
            </div>
            <div className="amenities_table">
                <TableSimple
                    columns={columns}
                    data={removeDuplicateRooms(data?.Room)}
                    highlightOnHover={false}
                />
            </div>
        </div>
    );
};
